import { useEffect, useState } from "react";
import { CasAuthApi, CasProfileApi, CasPurposesApi, getUser } from "@jti/rest-api";
import { useConfig } from "../../providers/useConfig";
export var Conditions;
(function (Conditions) {
    Conditions["LOGGED_IN"] = "LOGGED_IN";
    Conditions["AGE_VERIFIED"] = "AGE_VERIFIED";
    Conditions["DEVICE_REGISTRATION"] = "DEVICE_REGISTRATION";
    Conditions["PURPOSE"] = "PURPOSE";
})(Conditions || (Conditions = {}));
export const useLoyaltyRestrictedContent = () => {
    const [restrictedConditions, setRestrictedConditions] = useState(null);
    const [isRestricted, setIsRestricted] = useState(true);
    const { loyaltyRestrictionPurpose, isDeviceRegisteredRestriction, IS_LOYALTY_ENABLED, isAgeVerifiedLoyaltyRestriction, isLoyaltyContentRestricted, } = useConfig();
    const checkLoginRestriction = async () => {
        const user = getUser();
        let sessionValidationStatus = false;
        if (user?.ciam_token) {
            const { statusCode } = await CasAuthApi.init().validate(user.ciam_token, true);
            sessionValidationStatus = statusCode === 200 || statusCode === 204;
        }
        return sessionValidationStatus;
    };
    const checkAgeRestriction = async (sessionValidationStatus) => {
        if (sessionValidationStatus) {
            const { is_age_verified } = await CasProfileApi.init().getProfile(true);
            return is_age_verified;
        }
        return false;
    };
    const checkPurposeRestriction = async (sessionValidationStatus) => {
        if (!sessionValidationStatus) {
            return [];
        }
        const data = await CasPurposesApi.init().getPurposesForUserByCategory("all", true);
        const purposesStatusList = data
            .filter(({ id }) => loyaltyRestrictionPurpose.includes(id))
            .map(({ id, accepted }) => ({ id, accepted }));
        return purposesStatusList;
    };
    useEffect(() => {
        const getRestrictionDetails = async () => {
            const conditions = [];
            if (isLoyaltyContentRestricted) {
                const sessionValidationStatus = await checkLoginRestriction();
                conditions.push({ condition: Conditions.LOGGED_IN, status: sessionValidationStatus });
                if (isAgeVerifiedLoyaltyRestriction) {
                    const isAgeVerified = await checkAgeRestriction(sessionValidationStatus);
                    conditions.push({ condition: Conditions.AGE_VERIFIED, status: isAgeVerified });
                }
                if (loyaltyRestrictionPurpose.length > 0) {
                    const purposesStatusList = await checkPurposeRestriction(sessionValidationStatus);
                    conditions.push({ condition: Conditions.PURPOSE, status: purposesStatusList });
                }
                if (isDeviceRegisteredRestriction) {
                    conditions.push({
                        condition: Conditions.DEVICE_REGISTRATION,
                        status: getUser().is_device_registered || false,
                    });
                }
            }
            if (conditions.length > 0) {
                setRestrictedConditions(conditions);
            }
            else {
                setIsRestricted(IS_LOYALTY_ENABLED !== "true");
            }
        };
        getRestrictionDetails().catch((error) => console.error(error));
    }, []);
    useEffect(() => {
        if (restrictedConditions) {
            const singleRestriction = (status) => !status;
            const multiRestriction = (status) => {
                return status.length > 0 && !status.every(({ accepted }) => accepted);
            };
            const hasRestrictedConditions = restrictedConditions.some(({ status }) => {
                if (Array.isArray(status)) {
                    return multiRestriction(status);
                }
                else {
                    return singleRestriction(status);
                }
            });
            setIsRestricted(hasRestrictedConditions);
        }
    }, [restrictedConditions]);
    return { restrictedConditions, isRestricted, isLoyaltyEnabled: IS_LOYALTY_ENABLED === "true" };
};
//# sourceMappingURL=useLoyaltyRestrictedContent.js.map